import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row, InputGroup } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Componente para la sección de Datos Fiscales del Emisor y Cliente
 * Soporta caracteres Unicode (acentos, ñ, símbolos especiales)
 */
const DatosFiscalesReceptorFactura = ({
    cargandoForm,
    errors,
    clearError,

    // Props de datos fiscales del cliente
    formData,
    handleChange,
    isForeignRFC,
    isGenericRFC,
    handleRFCChange
}) => {
    const { token, setToken } = useToken();

    const [regimenesFiscales, setRegimenesFiscales] = useState([])
    const [paises, setPaises] = useState([]);
    const [usoCFDI, setUsoCFDI] = useState([]);
    const [showGenericos, setShowGenericos] = useState(false);
    const { showErrorToast } = useToast();
    /**
     * Obtiene los Regimenes Fiscales
     */
    const ObtenerRegimenesFiscales = async () => {

        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerRegimenesFiscales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                // console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            // console.log("==== OBTENER REGIMENES FISCALES ====");

            // console.log("response: ", response);
            const data = await response.json();
            // console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //   console.log("ObjDetallesRF:", ObjDetalles);

                setRegimenesFiscales(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
    * Obtiene Uso CFDI
    */
    const ObtenerUsoCFDI = async () => {

        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerUsoCFDI",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("==== OBTENER USO CFDI ====");

            //console.log("response: ", response);
            const data = await response.json();
            // console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //console.log("ObjDetallesCFDI:", ObjDetalles);

                setUsoCFDI(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
   * Obtiene los paises del Cat Sat
   */
    const ObtenerCatPaises = async () => {
        if (paises.length > 0) return; // Ya están cargadas

        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerCatPaises",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("==== OBTENER PAIS ====");

            //console.log("response: ", response);
            const data = await response.json();
            //console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //console.log("ObjDetallesPais:", ObjDetalles);

                setPaises(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }


    useEffect(() => {
        ObtenerRegimenesFiscales();
        ObtenerUsoCFDI();
        ObtenerCatPaises();
    }, []);

    return (
        <>
            <h5 className="seccion-titulo mt-3 mb-3 bg-light p-2 rounded text-dark">Datos Fiscales del Receptor</h5>
            <Row className="mb-1">
                <Col xs={12} className="mb-2">
                    {/* Razn Social */}
                    <Form.Group>
                        <Form.Label className="form-label-profesional">Raz&oacute;n Social</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                : <Form.Control className="form-control-profesional" size="sm"
                                    autoComplete="off"
                                    type="text"
                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                    isInvalid={!!errors.vRazonSocial}
                                    value={formData.vRazonSocial || ""}
                                    onChange={(e) => {
                                        handleChange('vRazonSocial', e.target.value);
                                        if (e.target.value) {
                                            clearError("vRazonSocial");
                                        }
                                    }}
                                />
                        }
                        {errors.vRazonSocial && (
                            <Form.Text className="form-error-text">{errors.vRazonSocial}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-1">
                <Col xs={12} md={6} className="mb-2">
                    {/* RFC */}
                    <Form.Group>
                        <Form.Label className="form-label-profesional">
                            RFC
                        </Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <InputGroup size="sm">
                                    <Form.Control className="form-control-profesional"
                                        type="text"
                                        autoComplete="off"
                                        value={formData.vRFC || ""}
                                        onChange={(e) => {
                                            handleRFCChange(e.target.value);
                                            if (e.target.value) {
                                                clearError("vRFC");
                                            }
                                        }}
                                        isInvalid={!!errors.vRFC}
                                    />
                                    {!isForeignRFC && (
                                        <InputGroup.Text style={{ padding: '0 8px', backgroundColor: '#fff', borderLeft: 'none' }}>
                                            <img src="/img/bandera-mexico-48.png" alt="México" style={{ height: '14px' }} />
                                        </InputGroup.Text>
                                    )}
                                </InputGroup>
                        }
                        {errors.vRFC && (
                            <Form.Text className="form-error-text">{errors.vRFC}</Form.Text>
                        )}
                        {!cargandoForm && (
                            <div className="mt-1">
                                <a 
                                    href="#!" 
                                    className="text-decoration-none small" 
                                    onClick={(e) => { 
                                        e.preventDefault(); 
                                        setShowGenericos(!showGenericos); 
                                    }}
                                >
                                    {showGenericos ? 'Ocultar RFC Genéricos' : 'RFC Genéricos'}
                                </a>
                                {showGenericos && (
                                    <div className="d-flex gap-3 mt-1 flex-wrap bg-light p-2 rounded border">
                                        <Form.Check 
                                            type="radio"
                                            name="rfc-generico"
                                            id="rfc-nacional"
                                            label={<span style={{fontSize: '0.8rem'}}>XAXX010101000 (Nacional)</span>}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    handleRFCChange("XAXX010101000");
                                                    clearError("vRFC");
                                                    setShowGenericos(false);
                                                }
                                            }}
                                        />
                                        <Form.Check 
                                            type="radio"
                                            name="rfc-generico"
                                            id="rfc-extranjero"
                                            label={<span style={{fontSize: '0.8rem'}}>XEXX010101000 (Extranjero)</span>}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    handleRFCChange("XEXX010101000");
                                                    clearError("vRFC");
                                                    setShowGenericos(false);
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </Form.Group>
                </Col>

                <Col xs={12} md={6} className="mb-2">
                    <Form.Group>
                        <Form.Label className="form-label-profesional">C&oacute;digo Postal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control className="form-control-profesional" size="sm"
                                    type="text"
                                    inputMode="numeric"
                                    autoComplete="off"
                                    maxLength={5}
                                    value={formData.vCP || ""}
                                    disabled={isGenericRFC || isForeignRFC}
                                    onChange={(e) => {
                                        let valor = e.target.value.replace(/\D/g, ""); // Elimina caracteres no numéricos
                                        handleChange("vCP", valor);
                                        if (valor) {
                                            clearError("vCP"); // Limpia errores si se ingresa algo
                                        }
                                    }}
                                    isInvalid={!!errors.vCP}
                                />
                        }
                        {errors.vCP && (
                            <Form.Text className="form-error-text">{errors.vCP}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-1">
                <Col xs={12} className="mb-2">
                    {/* Régimen Fiscal */}
                    <Form.Group>
                        <Form.Label className="form-label-profesional">R&eacute;gimen Fiscal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Select className="form-control-profesional" size="sm"
                                    isInvalid={!!errors.vCodigoRegimen}
                                    value={formData.vCodigoRegimen || ""}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        handleChange("vCodigoRegimen", val);
                                        if (val) {
                                            clearError("vCodigoRegimen");
                                        }
                                    }}                            >
                                    <option value="">Selecciona un r&eacute;gimen</option>
                                    {regimenesFiscales.map((regimen, index) => (
                                        <option key={index} value={regimen.vCodigoRegimen}>
                                            {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                        </option>
                                    ))}
                                </Form.Select>
                        }
                        {errors.vCodigoRegimen && (
                            <Form.Text className="form-error-text">{errors.vCodigoRegimen}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-1">
                <Col xs={12} md={6} className="mb-2">
                    <Form.Group>
                        <Form.Label className="form-label-profesional">Uso CFDI</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Select className="form-control-profesional" size="sm"
                                    value={formData.vCodigoUso || ""}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        handleChange("vCodigoUso", val);
                                        if (val) {
                                            clearError("vCodigoUso");
                                        }
                                    }}
                                    isInvalid={!!errors.vCodigoUso}
                                >
                                    <option value="">Seleccione un Uso CFDI</option>
                                    {usoCFDI.map((cfdi, index) => (
                                        <option key={index} value={cfdi.vCodigoUso}>
                                            {cfdi.vCodigoUso} - {cfdi.vDescripcionUsoCFDI}
                                        </option>
                                    ))}
                                </Form.Select>
                        }
                        {errors.vCodigoUso && (
                            <Form.Text className="form-error-text">{errors.vCodigoUso}</Form.Text>
                        )}
                    </Form.Group>
                </Col>

                <Col xs={12} md={6} className="mb-2">
                    <Form.Group>
                        <Form.Label className="form-label-profesional">Email</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control className="form-control-profesional" size="sm"
                                    type="email"
                                    autoComplete="off"
                                    isInvalid={!!errors.vEmail}
                                    value={formData.vEmail || ""}
                                    onChange={(e) => {
                                        handleChange('vEmail', e.target.value);
                                        if (e.target.value) {
                                            clearError("vEmail");
                                        }
                                    }}
                                />
                        }
                        {errors.vEmail && (
                            <Form.Text className="form-error-text">{errors.vEmail}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* Campos adicionales para RFC extranjero */}
            {isForeignRFC && (
                <Row className="mb-1">
                    <Col xs={12} md={6} className="mb-2">
                        <Form.Group>
                            <Form.Label className="form-label-profesional">Pa&iacute;s de Residencia</Form.Label>
                            {
                                cargandoForm ?
                                    <Skeleton />
                                    :
                                    <Form.Select className="form-control-profesional" size="sm"
                                        value={formData.vPaisFacturacion || ""}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            handleChange("vPaisFacturacion", val);
                                            if (val) {
                                                clearError("vPaisFacturacion");
                                            }
                                        }}
                                        isInvalid={!!errors.vPaisFacturacion}
                                    >
                                        <option value="">Seleccione un Pa&iacute;s</option>
                                        {paises.map((name, index) => (
                                            <option key={index} value={name.cShortName}>
                                                {name.cShortName} - {name.vName}
                                            </option>
                                        ))}
                                    </Form.Select>
                            }
                            {errors.vPaisFacturacion && (
                                <Form.Text className="form-error-text">{errors.vPaisFacturacion}</Form.Text>
                            )}
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={6} className="mb-2">
                        <Form.Group>
                            <Form.Label className="form-label-profesional">N&uacute;m. Registro Tributario</Form.Label>
                            {
                                cargandoForm ?
                                    <Skeleton />
                                    :
                                    <Form.Control className="form-control-profesional" size="sm"
                                        type="text"
                                        value={formData.vNumRT || ""}
                                        maxLength={20}
                                        onChange={(e) => {
                                            handleChange('vNumRT', e.target.value);
                                            if (e.target.value) {
                                                clearError("vNumRT");
                                            }
                                        }}
                                        isInvalid={!!errors.vNumRT}
                                    />
                            }
                            {errors.vNumRT && (
                                <Form.Text className="form-error-text">{errors.vNumRT}</Form.Text>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
            )}

            {/* Campos adicionales para Factura Global */}
            {(formData.vRFC === "XAXX010101000" && formData.vRazonSocial === "PUBLICO EN GENERAL") && (
                <>
                    <h6 className="mt-3 mb-2" style={{ color: 'var(--falcon-primary)' }}>Información Global (CFDI 4.0)</h6>
                    <Row className="mb-1">
                        <Col xs={12} md={4} className="mb-2">
                            <Form.Group>
                                <Form.Label className="form-label-profesional">Periodicidad</Form.Label>
                                {
                                    cargandoForm ?
                                        <Skeleton />
                                        :
                                        <Form.Select className="form-control-profesional" size="sm"
                                            value={formData.informacionGlobal?.Periodicidad || ""}
                                            onChange={(e) => {
                                                handleChange("informacionGlobal.Periodicidad", e.target.value);
                                                if (e.target.value) clearError("informacionGlobal.Periodicidad");
                                            }}
                                            isInvalid={!!errors['informacionGlobal.Periodicidad']}
                                        >
                                            <option value="">Seleccione...</option>
                                            <option value="01">01 - Diario</option>
                                            <option value="02">02 - Semanal</option>
                                            <option value="03">03 - Quincenal</option>
                                            <option value="04">04 - Mensual</option>
                                            <option value="05">05 - Bimestral</option>
                                        </Form.Select>
                                }
                                {errors['informacionGlobal.Periodicidad'] && (
                                    <Form.Text className="form-error-text">{errors['informacionGlobal.Periodicidad']}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>

                        <Col xs={12} md={4} className="mb-2">
                            <Form.Group>
                                <Form.Label className="form-label-profesional">Mes</Form.Label>
                                {
                                    cargandoForm ?
                                        <Skeleton />
                                        :
                                        <Form.Select className="form-control-profesional" size="sm"
                                            value={formData.informacionGlobal?.Meses || ""}
                                            onChange={(e) => {
                                                handleChange("informacionGlobal.Meses", e.target.value);
                                                if (e.target.value) clearError("informacionGlobal.Meses");
                                            }}
                                            isInvalid={!!errors['informacionGlobal.Meses']}
                                        >
                                            <option value="">Seleccione...</option>
                                            <option value="01">01 - Enero</option>
                                            <option value="02">02 - Febrero</option>
                                            <option value="03">03 - Marzo</option>
                                            <option value="04">04 - Abril</option>
                                            <option value="05">05 - Mayo</option>
                                            <option value="06">06 - Junio</option>
                                            <option value="07">07 - Julio</option>
                                            <option value="08">08 - Agosto</option>
                                            <option value="09">09 - Septiembre</option>
                                            <option value="10">10 - Octubre</option>
                                            <option value="11">11 - Noviembre</option>
                                            <option value="12">12 - Diciembre</option>
                                            <option value="13">13 - Enero-Febrero</option>
                                            <option value="14">14 - Marzo-Abril</option>
                                            <option value="15">15 - Mayo-Junio</option>
                                            <option value="16">16 - Julio-Agosto</option>
                                            <option value="17">17 - Septiembre-Octubre</option>
                                            <option value="18">18 - Noviembre-Diciembre</option>
                                        </Form.Select>
                                }
                                {errors['informacionGlobal.Meses'] && (
                                    <Form.Text className="form-error-text">{errors['informacionGlobal.Meses']}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>

                        <Col xs={12} md={4} className="mb-2">
                            <Form.Group>
                                <Form.Label className="form-label-profesional">Año</Form.Label>
                                {
                                    cargandoForm ?
                                        <Skeleton />
                                        :
                                        <Form.Select className="form-control-profesional" size="sm"
                                            value={formData.informacionGlobal?.Anio || ""}
                                            onChange={(e) => {
                                                handleChange("informacionGlobal.Anio", e.target.value);
                                                if (e.target.value) clearError("informacionGlobal.Anio");
                                            }}
                                            isInvalid={!!errors['informacionGlobal.Anio']}
                                        >
                                            <option value="">Seleccione...</option>
                                            {[...Array(5).keys()].map(i => {
                                                const year = new Date().getFullYear() - i;
                                                return <option key={year} value={year}>{year}</option>
                                            })}
                                        </Form.Select>
                                }
                                {errors['informacionGlobal.Anio'] && (
                                    <Form.Text className="form-error-text">{errors['informacionGlobal.Anio']}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

DatosFiscalesReceptorFactura.propTypes = {
    // Props del emisor
    cargandoForm: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    clearError: PropTypes.func.isRequired,

    // Props de datos fiscales del cliente
    formData: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    isForeignRFC: PropTypes.bool.isRequired,
    handleRFCChange: PropTypes.func.isRequired
};

export default DatosFiscalesReceptorFactura;

